import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from 'vue';
import { useInitStore } from './ccm/stores/init';
import './ccm/assets/css/fontClasses.css';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ccm',
    setup(__props) {
        const initStore = useInitStore();
        onMounted(() => {
            initStore.user = window.ccm_user;
            window.ccm_user = undefined;
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
